var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchDrawer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_19661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9172 11.6662H12.2589L12.0255 11.4412C13.0255 10.2745 13.5422 8.68288 13.2589 6.99121C12.8672 4.67455 10.9339 2.82454 8.60052 2.54121C5.07552 2.10788 2.10885 5.07454 2.54219 8.59955C2.82552 10.9329 4.67552 12.8662 6.99219 13.2579C8.68386 13.5412 10.2755 13.0245 11.4422 12.0245L11.6672 12.2579V12.9162L15.2089 16.4579C15.5505 16.7995 16.1089 16.7995 16.4505 16.4579C16.7922 16.1162 16.7922 15.5579 16.4505 15.2162L12.9172 11.6662ZM7.91719 11.6662C5.84219 11.6662 4.16719 9.99121 4.16719 7.91621C4.16719 5.84121 5.84219 4.16621 7.91719 4.16621C9.99219 4.16621 11.6672 5.84121 11.6672 7.91621C11.6672 9.99121 9.99219 11.6662 7.91719 11.6662Z",
    fill: "#192F51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_19661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDrawer);
export default __webpack_public_path__ + "static/media/search-drawer.e2267588ad1051aa8cfd720114fba959.svg";
export { ForwardRef as ReactComponent };